<template>
    <v-container fluid>
      <div class="text-h6 white--text d-md-none" style="margin-top: 10px;">Pagamento Banricompras<br />{{ tipoCartao }}</div>
      <div class="text-h6 black--text d-none d-md-block" style="margin-top: 10px;">Pagamento Banricompras<br /> {{ tipoCartao }}</div>
      <div class="text-subtitle-1 white--text d-md-none" style="padding-top: 10px; line-height: 25px">
        Você pode usar o Banrisul Digital ou o Vero Pay para efetuar o pagamento,
        se você estiver utilizando um computador você também poderá pagar com o
        cartão Banrisul com CHIP porém você precisa de um leitor de cartão do banco.
      </div>
      <div class="text-subtitle-1 black--text d-none d-md-block" style="padding-top: 10px; line-height: 25px">
        Você pode usar o Banrisul Digital ou o Vero Pay para efetuar o pagamento,
        se você estiver utilizando um computador você também poderá pagar com o
        cartão Banrisul com CHIP porém você precisa de um leitor de cartão do banco.
      </div>
      <div>
        Qualquer dúvida ou problema com pagamento e ajuda por favor nos informe via whatsapp pelo número <a href="https://wa.me/555199926208">(51) 99992-6208</a> com Edgar, (basta clicar no telefone para abrir o whatsapp)</div>
    <v-img src="/img/banricompras.png" style="width: 180px" class="mx-auto" />
    <div class="text-center text-h6 font-weight-black">Total: R$ {{ carrinho.valor | fmtNumber }} Pagamento {{ tipoCartao }}</div>
    <v-btn class="cyan darken-2 white--text" block style="margin-top: 10px" @click="pagamentoCartaoBanricompras()">Efetuar Pagamento</v-btn>
    <v-btn block style="margin-top: 10px" @click="$router.go(-1)">Voltar</v-btn>
    <v-dialog :value="dialogCartao" persistent>
        <v-alert v-if="erroAjax" prominent type="error" icon="mdi-cloud-alert">
          {{ erroAjax }}
        </v-alert>
        <v-card v-else>
          <v-card-text class="text-h6 text-center">
          <div>Por favor aguarde ser redirecionado ao ambiente seguro do Banrisul</div>
          <div class="subtitle-1">Foi aberto uma nova janela para pagamento junto ao Banrisul, assim que o pagamento for confirmado você será redirecionado.</div>
          <v-progress-linear indeterminate color="primary"></v-progress-linear>
          </v-card-text>
        </v-card>
    </v-dialog>
    <v-dialog :value="successCartao" persistent>
        <v-card>
          <v-card-text class="text-h6 text-center green white--text">
            Pagamento efetuado com sucesso, você está sendo redirecionado
          <v-progress-linear indeterminate color="white"></v-progress-linear>
          </v-card-text>
        </v-card>
    </v-dialog>
    </v-container>
</template>
<script>
import { mapActions, mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['carrinho', 'dialogCartao', 'erroAjax', 'successCartao']),
    tipoCartao: function () {
      if (this.carrinho.forma_pagamento === 3) {
        return 'À Vista'
      } else {
        return '30 dias'
      }
    }
  },
  methods: {
    ...mapActions(['pagamentoCartaoBanricompras'])
  }
}
</script>
